// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"3cb7964f","822":"4823e726"}[chunkId] + ".chunk.js";
};